import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective, CardComponent, CardContentComponent } from '@nk/ui-lib';

@Component({
  selector: 'nk-sign-up-existing',
  imports: [CommonModule, RouterModule, TranslateModule, CardComponent, CardContentComponent, ButtonDirective],
  templateUrl: './sign-up-existing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpExistingComponent implements OnInit {
  public companyName: string;

  constructor(private _activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {
    this.companyName = this._activatedRoute.snapshot.queryParams['companyName'] as string;
  }
}
